/**
 * @constructor main.scroll.init()
 * More info http://github.com/cferdinandi/smooth-scroll
 */

main.scroll = (function () {
  var enableSmoothScroll = false;
  var enableReveal = true;
  var offset = 10; // Offset from bottom in %
  var threshold = window.innerHeight * ( 1 - (offset * 0.01));
  var items = document.getElementsByClassName('js-reveal');
  // var thresholdSlow = window.innerHeight * ( 1 - (offset  * 0.02));
  // var itemsSlow = document.getElementsByClassName('js-reveal-slow');

  var init = function () {
    if (enableSmoothScroll) { // see common_vendors for js file and polyfill
      var scroll = new SmoothScroll('a[href*="#"]');
    }
  };

  var handleVisiblity = function () {
    if (!enableReveal) { return; }
    _handleVisiblity(items, threshold);
    // _handleVisiblity(itemsSlow, thresholdSlow);
  };

  var _handleVisiblity = function (collection, tresholdCollection) {
    for (var i = 0; i < collection.length; i++) {
      var item = collection[i];
      if (main.utils.hasClass(item, 'is-revealed')) { continue; }

      if (item.getBoundingClientRect().top <= tresholdCollection) {
        main.utils.removeClass(item, 'u-transparent');
        main.utils.addClass(item, 'is-revealed');
      } else {
        main.utils.addClass(item, 'u-transparent');
      }
    }
  };



  return {
    init: init,
    handleVisiblity: handleVisiblity
  };
})();
